


















































import { Component, Vue, Prop, InjectReactive } from 'vue-property-decorator';
import { PaycheckForm } from './PaycheckForm';

@Component
export default class PaycheckWorkRelationInfo extends Vue {
  @Prop({ type: Object, required: true }) private paycheck!: PaycheckForm;
  @InjectReactive() private isLocked!: boolean;
  @InjectReactive() private hasEditPermissions!: boolean;
}
